<template>
  <div class="floating-contact">
    <!-- 배경 오버레이 -->
    <Transition name="fade">
      <div v-if="isLocationOpen" class="location-overlay" @click="closeLocationModal"></div>
    </Transition>

    <!-- 왼쪽 Location 탭 + 이미지 슬라이드 -->
    <div class="location-wrapper" :class="{ open: isLocationOpen }">
      <!-- 딸려 나오는 이미지 -->
      <div class="location-image">
        <img :src="locationImage" alt="입지 안내" />
      </div>

      <!-- 탭 버튼 (이미지) -->
      <div class="location-tab" @click="toggleLocation">
        <img :src="tabImage" alt="입지 확인하기" class="tab-image" />
      </div>
    </div>

    <!-- 우측 하단 플로팅 버튼들 -->
    <div class="floating-buttons">
      <!-- 팝업보기 버튼 (Location 열기) -->
      <button class="float-btn popup-btn" @click="toggleLocation">
        <span class="btn-inner">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" stroke-width="1.5"/>
            <path d="M3 9h18" stroke="currentColor" stroke-width="1.5"/>
            <circle cx="6" cy="6" r="1" fill="currentColor"/>
            <circle cx="9" cy="6" r="1" fill="currentColor"/>
          </svg>
          <span class="btn-text">팝업보기</span>
        </span>
      </button>

      <!-- 홍보영상 버튼 -->
      <button class="float-btn video-btn" @click="openVideo">
        <span class="btn-inner">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5"/>
            <circle cx="12" cy="12" r="10" fill="currentColor" opacity="0.08"/>
            <path d="M10 8.5v7l6-3.5-6-3.5z" fill="currentColor"/>
          </svg>
          <span class="btn-text">홍보영상</span>
        </span>
      </button>

      <!-- 고객등록 버튼 -->
      <button class="float-btn register-btn" @click="toggleForm">
        <span class="btn-inner">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="8" r="4" stroke="currentColor" stroke-width="1.5"/>
            <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
          <span class="btn-text">고객등록</span>
        </span>
      </button>
    </div>

    <!-- 홍보영상 모달 -->
    <Transition name="video-slide">
      <div v-if="isVideoOpen" class="video-overlay" @click.self="closeVideo">
        <div class="video-modal">
          <div class="video-container">
            <iframe
              :src="videoUrl"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
          <button class="video-close-btn" @click="closeVideo">영상 종료</button>
        </div>
      </div>
    </Transition>

    <!-- 고객등록 폼 패널 -->
    <div class="contact-panel" :class="{ open: isFormOpen }">
      <button class="panel-close" @click="isFormOpen = false">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M18 6L6 18M6 6l12 12"/>
        </svg>
      </button>

      <div class="panel-header">
        <h3>고객등록</h3>
        <p>빠른 상담을 위해 정보를 남겨주세요</p>
      </div>

      <form @submit.prevent="submitForm" class="contact-form">
        <div class="form-group">
          <input type="text" v-model="form.name" placeholder="성함" required :disabled="isSubmitting" />
        </div>
        <div class="form-group">
          <PhoneInput v-model="form.phone" :disabled="isSubmitting" required />
        </div>
        <div class="form-group checkbox-group">
          <label class="checkbox-label">
            <input type="checkbox" v-model="form.agreePrivacy" required :disabled="isSubmitting" />
            <span class="checkmark"></span>
            <span class="checkbox-text">
              개인정보 수집 동의
              <button type="button" class="privacy-link" @click="showPrivacy = true">보기</button>
            </span>
          </label>
        </div>
        <button type="submit" class="submit-btn" :disabled="isSubmitting">
          {{ isSubmitting ? '등록 중...' : '등록하기' }}
        </button>
      </form>
    </div>

    <!-- 개인정보처리방침 모달 -->
    <div v-if="showPrivacy" class="modal-overlay" @click.self="showPrivacy = false">
      <div class="privacy-modal">
        <h2>개인정보 수집 및 이용 동의</h2>
        <div class="privacy-content">
          <p><strong>[수집항목]</strong> 성함, 연락처</p>
          <p><strong>[이용목적]</strong> 상담 및 안내</p>
          <p><strong>[보유기간]</strong> 목적 달성 후 즉시 파기</p>
        </div>
        <button class="privacy-close-btn" @click="showPrivacy = false">확인</button>
      </div>
    </div>
  </div>
</template>

<script>
import { saveConsultation } from '@/firebase/consultationService'
import PhoneInput from '@/components/common/PhoneInput.vue'

export default {
  name: 'FloatingContact',
  components: { PhoneInput },
  data() {
    return {
      isFormOpen: false,
      isVideoOpen: false,
      isLocationOpen: false,
      showPrivacy: false,
      isSubmitting: false,
      videoUrl: '',
      locationImage: require('@/assets/popup/1.gif'),
      tabImage: require('@/assets/popup/2.jpg'),
      form: { name: '', phone: '', agreePrivacy: false }
    }
  },
  methods: {
    toggleForm() { this.isFormOpen = !this.isFormOpen },
    toggleLocation() {
      this.isLocationOpen = !this.isLocationOpen
      document.body.style.overflow = this.isLocationOpen ? 'hidden' : ''
    },
    closeLocationModal() {
      this.isLocationOpen = false
      document.body.style.overflow = ''
    },
    openVideo() {
      this.videoUrl = 'https://www.youtube.com/embed/-rYvNgn5FYo?autoplay=1&rel=0'
      this.isVideoOpen = true
      document.body.style.overflow = 'hidden'
    },
    closeVideo() {
      this.isVideoOpen = false
      this.videoUrl = ''
      document.body.style.overflow = ''
    },
    async submitForm() {
      if (!this.form.agreePrivacy) {
        alert('개인정보 수집 및 이용에 동의해주세요.')
        return
      }
      this.isSubmitting = true
      try {
        const result = await saveConsultation({ name: this.form.name, phone: this.form.phone }, 'pc-floating')
        if (result.success) {
          alert('등록이 완료되었습니다.')
          this.form = { name: '', phone: '', agreePrivacy: false }
          this.isFormOpen = false
        } else {
          alert('오류가 발생했습니다.')
        }
      } catch (error) {
        alert('오류가 발생했습니다.')
      } finally {
        this.isSubmitting = false
      }
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;1,300;1,400;1,500&display=swap');

.floating-contact {
  position: fixed;
  z-index: 999;
}

/* ===== 배경 오버레이 ===== */
.location-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 999;
}

/* fade 트랜지션 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* ===== 왼쪽 Location 래퍼 ===== */
.location-wrapper {
  position: fixed;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1000;
  display: flex;
  align-items: center;
}

/* 딸려 나오는 이미지 */
.location-image {
  max-width: 0;
  overflow: hidden;
  transition: max-width 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.location-wrapper.open .location-image {
  max-width: 1200px;
}

.location-image img {
  height: 70vh;
  width: auto;
  display: block;
  border-radius: 0 20px 20px 0;
}

/* 탭 버튼 (이미지) */
.location-tab {
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 0 14px 14px 0;
  box-shadow: 4px 0 20px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.location-tab:hover {
  transform: scale(1.02);
  box-shadow: 4px 0 30px rgba(0, 0, 0, 0.2);
}

.tab-image {
  width: 90px;
  height: auto;
  display: block;
  border-radius: 0 14px 14px 0;
}

/* ===== 플로팅 버튼들 ===== */
.floating-buttons {
  position: fixed;
  bottom: 24px;
  right: 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
}

.float-btn {
  position: relative;
  border: none;
  cursor: pointer;
  background: transparent;
  padding: 0;
  display: flex;
  align-items: center;
}

.btn-inner {
  height: 56px;
  border-radius: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 18px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  position: relative;
  z-index: 2;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.btn-inner svg {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.btn-text {
  white-space: nowrap;
  font-size: 13px;
  font-weight: 700;
  margin-left: 0;
  max-width: 0;
  overflow: hidden;
  opacity: 0;
  transition: max-width 0.35s ease, margin-left 0.35s ease, opacity 0.25s ease;
}

.float-btn:hover .btn-inner {
  transform: translateY(-2px);
}

.float-btn:hover .btn-text {
  max-width: 80px;
  margin-left: 10px;
  opacity: 1;
}

/* 팝업보기 버튼 (골드) */
.popup-btn .btn-inner {
  background: linear-gradient(135deg, var(--main-color1), var(--main-color2));
  color: #fff;
  border: none;
}

.popup-btn:hover .btn-inner {
  box-shadow: 0 8px 28px rgba(166, 124, 82, 0.4);
}

/* 홍보영상 & 고객등록 버튼 */
.video-btn .btn-inner,
.register-btn .btn-inner {
  background: #fff;
  color: #666;
  border: 1px solid #e5e5e5;
}

.video-btn:hover .btn-inner,
.register-btn:hover .btn-inner {
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.15);
  color: #333;
}

/* ===== 홍보영상 모달 ===== */
.video-overlay {
  position: fixed;
  inset: 0;
  background: linear-gradient(180deg, rgba(0,0,0,0.95), rgba(0,0,0,0.85));
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 40px;
}

.video-modal {
  width: 100%;
  max-width: 900px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

.video-container {
  width: 100%;
  padding-bottom: 56.25%;
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);
}

.video-container iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.video-close-btn {
  padding: 14px 40px;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  border-radius: 30px;
  cursor: pointer;
  transition: all 0.3s;
}

.video-close-btn:hover {
  background: rgba(255, 255, 255, 0.1);
}

.video-slide-enter-active { animation: slideDown 0.4s ease; }
.video-slide-leave-active { animation: slideUp 0.3s ease; }

@keyframes slideDown {
  from { opacity: 0; transform: translateY(-100%); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes slideUp {
  from { opacity: 1; transform: translateY(0); }
  to { opacity: 0; transform: translateY(-50%); }
}

/* ===== 고객등록 폼 ===== */
.contact-panel {
  position: fixed;
  bottom: 90px;
  right: 24px;
  width: 300px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 16px 50px rgba(0, 0, 0, 0.15);
  opacity: 0;
  visibility: hidden;
  transform: translateY(10px);
  transition: all 0.3s;
  overflow: hidden;
  z-index: 1000;
}

.contact-panel.open {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.panel-close {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 28px;
  height: 28px;
  border: none;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  z-index: 10;
}

.panel-close svg {
  width: 14px;
  height: 14px;
}

.panel-header {
  background: linear-gradient(135deg, var(--main-color1), var(--main-color2));
  color: #fff;
  padding: 24px 20px;
  text-align: center;
}

.panel-header h3 {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 6px;
}

.panel-header p {
  font-size: 13px;
  opacity: 0.9;
}

.contact-form {
  padding: 20px;
}

.form-group {
  margin-bottom: 12px;
}

.form-group input[type="text"],
.form-group input[type="tel"] {
  width: 100%;
  padding: 14px 16px;
  border: 1px solid #eee;
  border-radius: 10px;
  font-size: 14px;
  background: #fafafa;
}

.form-group input:focus {
  outline: none;
  border-color: var(--main-color1);
  background: #fff;
}

.form-group :deep(.phone-segment) {
  padding: 14px 6px;
  border: 1px solid #eee;
  border-radius: 10px;
  font-size: 14px;
  background: #fafafa;
}

.form-group :deep(.phone-segment:focus) {
  outline: none;
  border-color: var(--main-color1);
  background: #fff;
}

.checkbox-group {
  margin: 16px 0;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 13px;
  color: #666;
}

.checkbox-label input { display: none; }

.checkmark {
  width: 18px;
  height: 18px;
  border: 2px solid #ddd;
  border-radius: 4px;
  position: relative;
}

.checkbox-label input:checked + .checkmark {
  background: var(--main-color1);
  border-color: var(--main-color1);
}

.checkbox-label input:checked + .checkmark::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 5px;
  width: 4px;
  height: 8px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.privacy-link {
  background: none;
  border: none;
  color: var(--main-color1);
  text-decoration: underline;
  cursor: pointer;
  font-size: 12px;
}

.submit-btn {
  width: 100%;
  padding: 14px;
  background: linear-gradient(135deg, var(--main-color1), var(--main-color2));
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
}

.submit-btn:hover:not(:disabled) {
  box-shadow: 0 6px 20px rgba(166, 124, 82, 0.3);
}

/* ===== 개인정보 모달 ===== */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2001;
  padding: 20px;
}

.privacy-modal {
  background: #fff;
  border-radius: 16px;
  max-width: 360px;
  width: 100%;
  padding: 24px;
}

.privacy-modal h2 {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 16px;
}

.privacy-content p {
  font-size: 13px;
  color: #555;
  line-height: 1.6;
  margin-bottom: 8px;
}

.privacy-close-btn {
  width: 100%;
  margin-top: 16px;
  padding: 12px;
  background: linear-gradient(135deg, var(--main-color1), var(--main-color2));
  color: #fff;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
}

@media (max-width: 768px) {
  .floating-contact { display: none; }
}
</style>
